import TeacherDirectorySection from './TeacherDirectorySection';
import { TeacherDirectorySectionProps, TeacherDirectorySectionValueProps } from './types';

export type { TeacherDirectorySectionProps, TeacherDirectorySectionValueProps };
export default TeacherDirectorySection;
